module.exports = __webpack_public_path__ + "img/Hubschrauber.d79e1dc7.svg";